import { FETCH_DRIVER_REQUEST } from "./index";

export const loadDrivers = (token, filter) => ({
  type: FETCH_DRIVER_REQUEST,
  payload: {
    token,
    ...filter
  }
});
